<template>
  <div class="banner">
    <div class="module">
      <div class="logo"></div>
      <div class="slogan"></div>
      <div class="download-box">
        <div class="qrcode">
          <span>扫码下载游戏</span>
        </div>
        <div class="btns">
          <div class="btn-download ios" @click="downloadByOs(1)"></div>
          <div class="btn-download android" @click="downloadByOs(2)"></div>
        </div>
      </div>
      <div class="btn-try" @click="download"></div>
    </div>
  </div>
</template>

<script>
import { isWechat } from "@/utils/common";
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      iosUrl: 'https://apps.apple.com/cn/app/id1606852040',
      androidUrl: 'https://down.zisugame.com/apk/s0005021851/yNHnO0',
    }
  },
  methods: {
    ...mapMutations(['setWechatTipsVisible', 'setNavShow']),
    // 下载
    download() {
      if (navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)) {
        this.downloadByOs(1)
      } else {
        this.downloadByOs(2)
      }
    },
    // 根据系统下载
    downloadByOs(os) {
      setTimeout(() => {
        switch (os) {
          case 1: // IOS
            window.open(this.iosUrl, '_blank')
            break
          case 2: // 安卓
            if (isWechat()) {
              this.$emit('click')
              this.setWechatTipsVisible({ visible: true })
              this.setNavShow({ visible: false })
              return
            }
            window.open(this.androidUrl, '_blank')
            break
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 1095px;
  background: url('~@/assets/img/bg_banner.jpg') no-repeat;
  background-position: center;
}

.logo {
  position: absolute;
  top: 20px;
  left: 40px;
  width: 222px;
  height: 126px;
  background: url('~@/assets/img/logo.png') no-repeat;
}

.slogan {
  position: absolute;
  top: 186px;
  left: 60px;
  width: 834px;
  height: 341px;
  background: url('~@/assets/img/slogan.png') no-repeat;
}

.download-box {
  position: absolute;
  top: 602px;
  left: 208px;
  width: 488px;
  height: 238px;
  background: url('~@/assets/img/bg_download.png') no-repeat;

  .qrcode {
    position: absolute;
    top: 31px;
    left: 33px;
    width: 204px;
    height: 176px;
    background: url('~@/assets/img/qrcode.png') no-repeat;

    span {
      margin-top: 12px;
      writing-mode: vertical-lr;
      font-size: 21px;
      color: #fff;
      letter-spacing: 5px;
    }
  }

  .btns{
    position: absolute;
    top: 38px;
    right: 25px;

    .btn-download {
      width: 208px;
      height: 75px;
      cursor: pointer;

      &.ios {
        margin-bottom: 14px;
        background: url('~@/assets/img/btn_download_ios.png') no-repeat;
      }

      &.android {
        background: url('~@/assets/img/btn_download_android.png') no-repeat;
      }
    }
  }
}

.btn-try {
  position: absolute;
  top: 868px;
  left: 260px;
  width: 340px;
  height: 123px;
  background: url('~@/assets/img/btn_download.png') no-repeat;
  cursor: pointer;

  &:hover {
    background-position: 0 -123px;
  }
}
</style>
